import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { makeStyles, createStyles } from "@material-ui/core";
import { ITheme } from "../../Layout/themes";
import { Text } from "../../Ui/Text";
import {
  IRecipientTicketInfo,
  ShareStatus
} from "../../../interface/IShareInfo";
import ReactPlaceholder from "react-placeholder/lib";
import CheckedCircle from "@material-ui/icons/CheckCircleOutline";
import qs from "query-string";
const ShareIcon = require("../../../../../public/images/icons/share-icon-blue.svg");

const useStyles = makeStyles(({ palette }: ITheme) => {
  return createStyles({
    shareIcon: {
      color: palette.primary.main,
      width: "3.4em",
      height: "3.1em",
      fontSize: "1.8rem",
      display: "block",
      margin: "4rem auto 2rem auto",
      "& > g": {
        fill: "red"
      }
    },
    headingText: {
      fontSize: "2.3rem",
      lineHeight: 1.17,
      color: "#414141",
      textAlign: "center",
      marginLeft: "auto",
      marginRight: "auto"
    },
    bodyText: {
      marginTop: 6,
      lineHeight: 1,
      textAlign: "center",
      marginLeft: "auto",
      marginRight: "auto",
      marginBottom: "2rem"
    },
    successIcon: {
      fontSize: "8rem",
      display: "block",
      margin: "4rem auto 1.5rem auto",
      color: palette.success.main
    },
    headingTextSucess: {
      fontSize: "2rem",
      lineHeight: 1.17,
      color: "#414141",
      textAlign: "center",
      marginLeft: "auto",
      marginRight: "auto",
      marginBottom: "2rem"
    }
  });
});

interface IProps {
  loading: boolean;
  isAuthenticated: () => boolean;
  recipientTicketInfo: IRecipientTicketInfo;
}

export const HeadingSection = ({
  loading,
  isAuthenticated,
  recipientTicketInfo
}: IProps) => {
  const classes = useStyles({});
  const isUserSignedIn = isAuthenticated();
  const location = useLocation();
  const { name } = qs.parse(location.search);

  if (
    isUserSignedIn &&
    recipientTicketInfo &&
    recipientTicketInfo.shareStatus === ShareStatus.Accepted
  ) {
    return (
      <React.Fragment>
        <CheckedCircle className={classes.successIcon} />
        <Text className={classes.headingTextSucess} variant="h5">
          Ticket accepted!
        </Text>
      </React.Fragment>
    );
  }
  let eventName ="";
  if(recipientTicketInfo != null && recipientTicketInfo.venueInfo != null ){
    eventName = "for " + recipientTicketInfo.venueInfo.eventName;
  }
  return (
    <React.Fragment>
      {/*<ShareIcon.ReactComponent
        className={classes.shareIcon}
        viewBox="0 0 34 31"
      />*/}
      <Text className={classes.headingText} variant="h5">
        Accept ticket from {name || ""} {  eventName }
      </Text>
      <Text className={classes.bodyText} variant="body1">
        {isUserSignedIn
          ? "Accept this ticket to save it to your ticket wallet"
          : "Sign in or create an account to save this ticket to your ticket wallet"}
      </Text>
    </React.Fragment>
  );
};
